import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { ResultError } from './result-error';

export class NotAllowedInThisApplication extends ResultError {
    constructor(pickId: string) {
        super(pickId);
        this.type = PlacementErrorType.NotAllowedInThisApplication;
    }
}
